import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  feedbackApiAuthInterceptor,
  feedbackApiLoadingInterceptor,
  provideFeedbackApi,
} from '@brafton/feedback-api';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { provideBraftonSessionCookieSync } from './core/brafton-session-cookie';
import { provideSkynetAuth } from './core/skynet-auth.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withFetch(),
      withInterceptors([feedbackApiAuthInterceptor, feedbackApiLoadingInterceptor]),
    ),
    // `refreshTokenOn401` lets the interceptor replace a token the API has
    // rejected and replay the call, so an expired one heals mid-session instead
    // of failing every request until the next sign-out.
    provideFeedbackApi({ baseUrl: environment.apiBaseUrl, refreshTokenOn401: true }),
    // The org auth library (@brafton/skynet-angular-security-service) gates the
    // UI: Auth0 Lock redirect login + the route guard in core/auth.guard.ts. The
    // API token is separate — it is fetched from GET /v1/token by that guard
    // after login, so the endpoint is never hit for anonymous visitors. See
    // core/skynet-auth.config.ts for why the Auth0 token is not used for the API.
    provideSkynetAuth(),
    // Mirror the ID token into a .brafton.com cookie so the embedded
    // /auth-bridge iframe can read it cross-site via Storage Access.
    provideBraftonSessionCookieSync(),
  ],
};
